import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {useThemeMode} from '../../../_metronic/partials'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

const BODY_CLASSES = ['bgi-size-cover', 'bgi-position-center', 'bgi-no-repeat']
const LandingLayout = () => {
  const {mode} = useThemeMode()
  useEffect(() => {
    BODY_CLASSES.forEach((c) => document.body.classList.add(c))
    document.body.style.backgroundImage =
      mode === 'dark'
        ? `url(${toAbsoluteUrl('/media/auth/bg7-dark.jpg')})`
        : `url(${toAbsoluteUrl('/media/auth/bg7.jpg')})`

    return () => {
      BODY_CLASSES.forEach((c) => document.body.classList.remove(c))
      document.body.style.backgroundImage = 'none'
    }
  }, [mode])

  return (
    <div className='d-flex flex-column flex-root'>
      {/* Navigation */}
      <nav className='navbar navbar-expand-lg py-3' style={{backgroundColor: 'rgba(255,255,255,0.95)'}}>
        <div className='container'>
          <a className='navbar-brand' href='#'>
            <span className='ms-2 fw-bold fs-3' style={{color: '#2464ac'}}>
              {/* <i className='fas fa-microchip me-2'></i>IoTMonitor Pro */}
              <img alt='Logo' src={toAbsoluteUrl('/media/logos/Sense-it-logo-BLUE.png')} className='h-35px' />
            </span>
          </a>
          <button className='navbar-toggler' type='button' data-bs-toggle='collapse' data-bs-target='#navbarNav'>
            <span className='navbar-toggler-icon'></span>
          </button>
          <div className='collapse navbar-collapse' id='navbarNav'>
            <ul className='navbar-nav ms-auto'>
              <li className='nav-item'><a className='nav-link' href='#features' style={{color: '#2464ac'}}>Features</a></li>
              <li className='nav-item'><a className='nav-link' href='#how-it-works' style={{color: '#2464ac'}}>How It Works</a></li>
              <li className='nav-item'><a className='nav-link' href='#pricing' style={{color: '#2464ac'}}>Pricing</a></li>
              <li className='nav-item'><a className='nav-link' href='#contact' style={{color: '#2464ac'}}>Contact</a></li>
            </ul>
            <div className='ms-lg-3'>
              {/* <a className='btn btn-sm me-2' href='/auth/register' style={{backgroundColor: 'transparent', color: '#2464ac', border: '1px solid #2464ac'}}>Sign In</a> */}
              <a className='btn btn-sm' href={toAbsoluteUrl('/auth/login')} style={{backgroundColor: '#2464ac', color: 'white'}}>Sign In</a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className='py-15 py-lg-20' style={{
        background: 'linear-gradient(135deg, #2464ac 0%, #1a4a82 100%)',
        color: 'white',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div className="position-absolute" style={{
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          background: 'radial-gradient(circle at top right, rgba(72, 149, 239, 0.5) 0%, transparent 50%)',
          pointerEvents: 'none'
        }}></div>
        
        <div className='container position-relative'>
          <div className='row align-items-center'>
            <div className='col-lg-6'>
              <h1 className='display-4 fw-bold mb-5 text-light'>Monitor Your IoT Ecosystem with Precision</h1>
              <p className='lead mb-7' style={{opacity: 0.9}}>Real-time monitoring, predictive analytics, and seamless control of all your connected devices from a single dashboard.</p>
              <div className='d-flex flex-wrap'>
                <a href='#demo' className='btn btn-lg me-4 mb-3' style={{backgroundColor: 'white', color: '#2464ac'}}>Request Demo</a>
                <a href='#pricing' className='btn btn-lg btn-outline mb-3' style={{borderColor: 'white', color: 'white'}}>View Pricing</a>
              </div>
            </div>
            <div className='col-lg-6'>
              <div className="position-relative">
                <div className="position-absolute" style={{
                  top: '-20px',
                  right: '-20px',
                  bottom: '20px',
                  left: '20px',
                  border: '2px solid rgba(255,255,255,0.2)',
                  borderRadius: '12px',
                  zIndex: 0
                }}></div>
                <div className="position-relative bg-dark rounded shadow-lg" style={{
                  height: '300px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 1,
                  overflow: 'hidden'
                }}>
                  {/* <div className="text-center p-4">
                    <i className="fas fa-tachometer-alt fs-1 text-light mb-3"></i>
                    <p className="text-light">IoT Dashboard Preview</p>
                    <small className="text-muted">Replace with your dashboard image</small>
                  </div> */}
                  <img 
                    src={toAbsoluteUrl('/media/panel.png')} 
                    alt='IoT Monitoring Dashboard' 
                    className='img-fluid rounded shadow-lg position-relative'
                    style={{zIndex: 1}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id='features' className='py-15' style={{backgroundColor: '#f8f9fa'}}>
        <div className='container'>
          <div className='text-center mb-15'>
            <h2 className='display-4 fw-bold mb-5' style={{color: '#2464ac'}}>Powerful Features</h2>
            <p className='lead text-muted'>Everything you need to manage your IoT infrastructure effectively</p>
          </div>
          <div className='row'>
            <div className='col-md-4 mb-10'>
              <div className='text-center'>
                <div className='rounded-circle d-inline-flex align-items-center justify-content-center mb-5' style={{width: '80px', height: '80px', backgroundColor: 'rgba(36, 100, 172, 0.1)'}}>
                  <i className='fas fa-chart-line fs-1' style={{color: '#2464ac'}}></i>
                </div>
                <h4 className='fw-bold mb-3' style={{color: '#2464ac'}}>Real-time Analytics</h4>
                <p className='text-muted'>Monitor device performance and data streams in real-time with customizable dashboards.</p>
              </div>
            </div>
            <div className='col-md-4 mb-10'>
              <div className='text-center'>
                <div className='rounded-circle d-inline-flex align-items-center justify-content-center mb-5' style={{width: '80px', height: '80px', backgroundColor: 'rgba(36, 100, 172, 0.1)'}}>
                  <i className='fas fa-bell fs-1' style={{color: '#2464ac'}}></i>
                </div>
                <h4 className='fw-bold mb-3' style={{color: '#2464ac'}}>Smart Alerts</h4>
                <p className='text-muted'>Receive instant notifications when devices need attention or parameters exceed thresholds.</p>
              </div>
            </div>
            <div className='col-md-4 mb-10'>
              <div className='text-center'>
                <div className='rounded-circle d-inline-flex align-items-center justify-content-center mb-5' style={{width: '80px', height: '80px', backgroundColor: 'rgba(36, 100, 172, 0.1)'}}>
                  <i className='fas fa-shield-alt fs-1' style={{color: '#2464ac'}}></i>
                </div>
                <h4 className='fw-bold mb-3' style={{color: '#2464ac'}}>Advanced Security</h4>
                <p className='text-muted'>End-to-end encryption and secure protocols to protect your IoT ecosystem from threats.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section id='how-it-works' className='py-15' style={{backgroundColor: 'white'}}>
        <div className='container'>
          <div className='text-center mb-15'>
            <h2 className='display-4 fw-bold mb-5' style={{color: '#2464ac'}}>How It Works</h2>
            <p className='lead text-muted'>Simple setup, powerful results</p>
          </div>
          <div className='row'>
            <div className='col-lg-3 col-md-6 mb-10'>
              <div className='text-center'>
                <div className='position-relative mb-7'>
                  <div className='rounded-circle d-inline-flex align-items-center justify-content-center' style={{width: '60px', height: '60px', backgroundColor: '#2464ac'}}>
                    <span className='text-white fw-bold fs-3'>1</span>
                  </div>
                </div>
                <h4 className='fw-bold mb-3' style={{color: '#2464ac'}}>Connect Devices</h4>
                <p className='text-muted'>Connect your IoT devices using our secure gateway or API integration.</p>
              </div>
            </div>
            <div className='col-lg-3 col-md-6 mb-10'>
              <div className='text-center'>
                <div className='position-relative mb-7'>
                  <div className='rounded-circle d-inline-flex align-items-center justify-content-center' style={{width: '60px', height: '60px', backgroundColor: '#2464ac'}}>
                    <span className='text-white fw-bold fs-3'>2</span>
                  </div>
                </div>
                <h4 className='fw-bold mb-3' style={{color: '#2464ac'}}>Configure Dashboard</h4>
                <p className='text-muted'>Customize your monitoring dashboard with the metrics that matter to you.</p>
              </div>
            </div>
            <div className='col-lg-3 col-md-6 mb-10'>
              <div className='text-center'>
                <div className='position-relative mb-7'>
                  <div className='rounded-circle d-inline-flex align-items-center justify-content-center' style={{width: '60px', height: '60px', backgroundColor: '#2464ac'}}>
                    <span className='text-white fw-bold fs-3'>3</span>
                  </div>
                </div>
                <h4 className='fw-bold mb-3' style={{color: '#2464ac'}}>Set Alerts</h4>
                <p className='text-muted'>Define parameters and thresholds to receive proactive notifications.</p>
              </div>
            </div>
            <div className='col-lg-3 col-md-6 mb-10'>
              <div className='text-center'>
                <div className='position-relative mb-7'>
                  <div className='rounded-circle d-inline-flex align-items-center justify-content-center' style={{width: '60px', height: '60px', backgroundColor: '#2464ac'}}>
                    <span className='text-white fw-bold fs-3'>4</span>
                  </div>
                </div>
                <h4 className='fw-bold mb-3' style={{color: '#2464ac'}}>Gain Insights</h4>
                <p className='text-muted'>Analyze data trends and optimize your operations with actionable intelligence.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className='py-15' style={{backgroundColor: '#f8f9fa'}}>
        <div className='container'>
          <div className='text-center mb-15'>
            <h2 className='display-4 fw-bold mb-5' style={{color: '#2464ac'}}>Trusted by Industry Leaders</h2>
            <p className='lead text-muted'>See what our customers say about us</p>
          </div>
          <div className='row'>
            <div className='col-md-4 mb-10'>
              <div className='card h-100 shadow-sm'>
                <div className='card-body'>
                  <div className='d-flex align-items-center mb-4'>
                    <div className='rounded-circle me-3 d-flex align-items-center justify-content-center' style={{width: '50px', height: '50px', backgroundColor: '#2464ac', color: 'white'}}>SJ</div>
                    <div>
                      <h5 className='card-title mb-0'>Sarah Johnson</h5>
                      <small className='text-muted'>CTO, SmartTech Solutions</small>
                    </div>
                  </div>
                  <p className='card-text'>"IoTMonitor Pro has transformed how we manage our fleet of devices. The predictive analytics have reduced our downtime by 43%."</p>
                </div>
              </div>
            </div>
            <div className='col-md-4 mb-10'>
              <div className='card h-100 shadow-sm'>
                <div className='card-body'>
                  <div className='d-flex align-items-center mb-4'>
                    <div className='rounded-circle me-3 d-flex align-items-center justify-content-center' style={{width: '50px', height: '50px', backgroundColor: '#2464ac', color: 'white'}}>MC</div>
                    <div>
                      <h5 className='card-title mb-0'>Michael Chen</h5>
                      <small className='text-muted'>IoT Director, Global Manufacturing</small>
                    </div>
                  </div>
                  <p className='card-text'>"The alert system is incredibly robust. We've been able to prevent critical failures before they happen, saving thousands in maintenance costs."</p>
                </div>
              </div>
            </div>
            <div className='col-md-4 mb-10'>
              <div className='card h-100 shadow-sm'>
                <div className='card-body'>
                  <div className='d-flex align-items-center mb-4'>
                    <div className='rounded-circle me-3 d-flex align-items-center justify-content-center' style={{width: '50px', height: '50px', backgroundColor: '#2464ac', color: 'white'}}>ER</div>
                    <div>
                      <h5 className='card-title mb-0'>Elena Rodriguez</h5>
                      <small className='text-muted'>Operations Manager, City Utilities</small>
                    </div>
                  </div>
                  <p className='card-text'>"Implementation was seamless, and our team was up and running in days. The ROI was evident within the first quarter of use."</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className='py-15' style={{
        background: 'linear-gradient(135deg, #2464ac 0%, #1a4a82 100%)',
        color: 'white'
      }}>
        <div className='container'>
          <div className='text-center'>
            <h2 className='display-4 fw-bold mb-5 text-white'>Ready to Transform Your IoT Management?</h2>
            <p className='lead mb-7' style={{opacity: 0.9}}>Join thousands of companies that trust our platform to monitor their IoT ecosystems.</p>
            <a href='/register' className='btn btn-lg' style={{backgroundColor: 'white', color: '#2464ac'}}>Start Your Free Trial</a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className='py-10' style={{backgroundColor: '#1a3b66', color: 'white'}}>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-4 mb-10 mb-lg-0'>
              <h5 className='mb-5'><i className='fas fa-microchip me-2'></i>IoTMonitor Pro</h5>
              <p className='text-light' style={{opacity: 0.7}}>Advanced monitoring solutions for the connected world.</p>
            </div>
            <div className='col-lg-2 col-md-4 mb-6 mb-md-0'>
              <h6 className='mb-4'>Product</h6>
              <ul className='list-unstyled'>
                <li><a href='#features' className='text-light text-hover-white' style={{opacity: 0.7}}>Features</a></li>
                <li><a href='#pricing' className='text-light text-hover-white' style={{opacity: 0.7}}>Pricing</a></li>
                <li><a href='#' className='text-light text-hover-white' style={{opacity: 0.7}}>Case Studies</a></li>
              </ul>
            </div>
            <div className='col-lg-2 col-md-4 mb-6 mb-md-0'>
              <h6 className='mb-4'>Resources</h6>
              <ul className='list-unstyled'>
                <li><a href='#' className='text-light text-hover-white' style={{opacity: 0.7}}>Documentation</a></li>
                <li><a href='#' className='text-light text-hover-white' style={{opacity: 0.7}}>Blog</a></li>
                <li><a href='#' className='text-light text-hover-white' style={{opacity: 0.7}}>Support</a></li>
              </ul>
            </div>
            <div className='col-lg-2 col-md-4'>
              <h6 className='mb-4'>Company</h6>
              <ul className='list-unstyled'>
                <li><a href='#' className='text-light text-hover-white' style={{opacity: 0.7}}>About Us</a></li>
                <li><a href='#' className='text-light text-hover-white' style={{opacity: 0.7}}>Careers</a></li>
                <li><a href='#contact' className='text-light text-hover-white' style={{opacity: 0.7}}>Contact</a></li>
              </ul>
            </div>
          </div>
          <hr className='my-10' style={{borderColor: 'rgba(255,255,255,0.1)'}}/>
          <div className='d-flex flex-column flex-md-row justify-content-between align-items-center'>
            <p className='mb-0' style={{opacity: 0.7}}>© 2023 IoTMonitor Pro. All rights reserved.</p>
            <div className='d-flex mt-3 mt-md-0'>
              <a href='#' className='text-light me-4' style={{opacity: 0.7}}><i className='fab fa-twitter'></i></a>
              <a href='#' className='text-light me-4' style={{opacity: 0.7}}><i className='fab fa-linkedin'></i></a>
              <a href='#' className='text-light' style={{opacity: 0.7}}><i className='fab fa-github'></i></a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export {LandingLayout}